import Module03Tile, { Module03TileProps } from './Module03Tile';

export type Module03Props = {
  tiles: Array<Module03TileProps>;
};

export const Module03 = ({ tiles }: Module03Props) => {
  return (
    <div className="grid gap-5 lg:grid-cols-3">
      {tiles.map((x, i) => (
        <Module03Tile key={i} {...x}></Module03Tile>
      ))}
    </div>
  );
};
